module.exports = __webpack_public_path__ + "static/media/Portrait-10204.e1385fb7.jpg";